import { useEffect, useRef, useState } from "react";
import { Globe, ChevronDown, Check } from "lucide-react";
import { LANGUAGES } from "@/lib/i18n";
import { useI18n } from "@/lib/I18nProvider";

export default function LanguageSwitcher({ compact = false }) {
  const { lang, setLang } = useI18n();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onDoc = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, []);

  const current = LANGUAGES.find((l) => l.code === lang) || LANGUAGES[0];

  return (
    <div ref={ref} className="relative" data-testid="language-switcher">
      <button
        data-testid="language-switcher-button"
        onClick={() => setOpen((s) => !s)}
        className="inline-flex items-center gap-2 px-3 py-2 rounded-full text-sm border border-white/15 text-zinc-200 hover:border-[#1FA8FF] hover:bg-white/[0.05] transition-colors"
      >
        <Globe size={14} className="text-[#1FE0A8]" />
        <span className="font-mono text-[11px] tracking-widest font-semibold">{current.short}</span>
        <ChevronDown size={14} className={`transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div
          data-testid="language-switcher-menu"
          className={`absolute ${compact ? "right-0" : "right-0"} mt-2 min-w-[180px] rounded-2xl border border-white/10 bg-[#324567] backdrop-blur-xl shadow-2xl py-2 z-50`}
        >
          {LANGUAGES.map((l) => (
            <button
              key={l.code}
              data-testid={`language-option-${l.code}`}
              onClick={() => { setLang(l.code); setOpen(false); }}
              className={`w-full flex items-center justify-between px-4 py-2.5 text-sm transition-colors ${
                l.code === lang ? "text-white bg-white/5" : "text-zinc-300 hover:bg-white/5 hover:text-white"
              }`}
            >
              <span className="flex items-center gap-3">
                <span className="text-base leading-none">{l.flag}</span>
                <span>{l.label}</span>
              </span>
              {l.code === lang && <Check size={14} className="text-[#1FE0A8]" />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
